import styled from "styled-components";

export const Page = styled.div`
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  box-sizing: border-box;
  padding: 1.25rem 1rem 2rem;
  padding-left: max(1rem, env(safe-area-inset-left));
  padding-right: max(1rem, env(safe-area-inset-right));
  padding-bottom: max(2rem, env(safe-area-inset-bottom));
  overflow-x: hidden;

  @media (max-width: 700px) {
    padding: 0.75rem 0.75rem 1.5rem;
    padding-left: max(0.75rem, env(safe-area-inset-left));
    padding-right: max(0.75rem, env(safe-area-inset-right));
  }
`;

export const Container = styled.div`
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 1.75rem 1.75rem 2rem;
  box-sizing: border-box;
  color: var(--text-primary);
  background: var(--surface-1);
  border-radius: 12px;
  overflow-x: hidden;

  font,
  p,
  span,
  td,
  th,
  li {
    color: inherit;
  }

  font[color="#38761d"] {
    color: var(--accent);
  }

  font[color="#0070c0"],
  a,
  a:link,
  a:visited {
    color: var(--info);
  }

  table,
  td,
  th {
    border-color: var(--border-default);
    max-width: 100%;
  }

  @media (max-width: 700px) {
    max-width: 100%;
    border-radius: 10px;
    padding: 1.1rem 1rem 1.35rem;
  }
`;

export const DocumentBody = styled.div`
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  font-size: 1rem;
  line-height: 1.65;
  overflow-wrap: anywhere;
  word-break: break-word;

  [title="header"],
  [title="footer"] {
    display: block;
    width: 100% !important;
    margin: 0 0 1rem;
  }

  [title="footer"] {
    display: none;
  }

  [title="header"] p {
    margin: 0 0 0.75rem !important;
    padding: 0 !important;
    white-space: normal !important;
    text-align: center !important;
    text-indent: 0 !important;
    font-size: 0.8rem !important;
    color: var(--text-secondary) !important;
  }

  p,
  li,
  td,
  th {
    max-width: 100%;
    margin-left: 0 !important;
    margin-right: 0 !important;
    text-indent: 0 !important;
    line-height: 1.65 !important;
  }

  p {
    margin-top: 0 !important;
    margin-bottom: 0.85rem !important;
  }

  p[align="center"] {
    text-align: center !important;
  }

  p[align="justify"] {
    text-align: left !important;
  }

  ol,
  ul {
    margin: 0 0 1rem;
    padding-left: 1.25rem;
    box-sizing: border-box;
  }

  li {
    margin-bottom: 0.5rem;
  }

  li > p {
    margin-bottom: 0.35rem !important;
  }

  font[size],
  font[style] {
    font-size: inherit !important;
  }

  a {
    word-break: break-all;
  }

  img,
  table {
    max-width: 100%;
    height: auto;
  }

  @media (max-width: 700px) {
    font-size: 0.95rem;
    line-height: 1.6;

    ol,
    ul {
      padding-left: 1.1rem;
    }

    p[align="center"] font,
    p[align="center"] {
      font-size: 1.05rem !important;
      line-height: 1.35 !important;
    }
  }
`;
